import { useState, useRef } from "react";
import { normalizeUrl } from "helpers/url";
import PropTypes from "prop-types";
import IconArrow from "assets/svg/chevron-down.svg";
import styles from "./styles.module.css";

const NearbyListings = ({ townName, townUrlList }) => {
  const containerRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleList = () => {
    if (isExpanded) {
      const containerHeight = containerRef.current.scrollHeight;
      window.scrollBy(0, -containerHeight + 150);
    }
    setIsExpanded((prev) => !prev);
  };

  return (
    <div ref={containerRef} className={styles.townsListContainer}>
      <h2 className={styles.title}>{`${townName} Mh. Yakın Diğer Mahalleler`}</h2>
      <div className={`${styles.townsList} ${isExpanded ? styles.expanded : ""}`}>
        {townUrlList.map((town) => (
          <a key={town.id} href={normalizeUrl(town.url, false)} className={styles.townName}>
            {town.name}
          </a>
        ))}
      </div>
      <button className={styles.toggleButton} onClick={toggleList}>
        {isExpanded ? "Daha Az Gör" : "Daha Fazla Gör"}
        <IconArrow className={`${styles.toggleIcon} ${isExpanded ? styles.up : ""}`} />
      </button>
    </div>
  );
};

NearbyListings.propTypes = {
  townName: PropTypes.string.isRequired,
  townUrlList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default NearbyListings;
